module.exports = ".fx-edit-cell-table table {\n  padding: 0 !important;\n}\n.fx-edit-cell-table .ant-table-placeholder {\n  display: none;\n}\n"